import miniApp, {
    analyticsBase,
    authorizeParams,
    gameRecorderStartParams,
    getUserInfoParams,
    loadParams,
    loginParams, ModalParams, SHARE_VIDEO_SORT_TYPE, ShareVideoRankDetail,
    toastParams,
    UserInfo
} from "../miniApp";
import {dataField} from "../dataField";
import {modules} from "../../../gameEngine";

const gamebox = window['gamebox'];
export default class gameBox4399 extends miniApp {
    async commitRank(rankId: dataField.RANK_ID, score: number): Promise<boolean> {
        return Promise.resolve(false);
        // throw new Error("Method not implemented.");
    }

    async showRank(rankId: dataField.RANK_ID): Promise<boolean> {
        return Promise.resolve(false);
        // throw new Error("Method not implemented.");
    }

    LocalInBlockCityList(): boolean {
        return false;
    }

    vibrate(type): void {
        console.log('游戏盒 4399 振动');
    }

    protected m_appId: string = '';
    protected m_secret: string = '';
    protected m_adUnitId: string = '';

    drawHead(headUrl: string): Promise<cc.SpriteFrame> {
        return Promise.resolve(null);
    }

    static getRandNameAndUrl(): UserInfo {
        let user: UserInfo = {
            nickName: `4399游客`,//侠客${data_control.getRandId(6)}
            avatarUrl: null,
            language: 'ch',
            gender: 0,
            country: '中国',        //用户所在国家
            province: '',        //用户所在省份
            city: '',            //用户所在城市
        };

        return user;
    };

    validAppId(): void {
    }

    getUserInfo(params: getUserInfoParams): void {
        params.success && params.success({userInfo: gameBox4399.getRandNameAndUrl()});
    }

    showToast(params: toastParams): void {
        // O1HD.getManagers().uiMgr.showMessageBox(params.title);
    }

    showLoading(params: loadParams): void {
        console.log('游戏盒 4399 显示进度', params);
    }

    hideLoading(): void {
        console.log('游戏盒 4399 隐藏进度');
    }

    preCreateUnits(): void {
        console.log('游戏盒 4399 预先创建');
        gamebox.login({
            success: res => {
                //成功
                console.log('登录成功');
            },
            fail: res => {
                console.log('登录失败');
            },
            complete: res => {
                //成功失败都会执行
            }
        });
    }

    loadAndShowVideoAd(successCallback: () => void, errorCallback: (error: any) => void, completeCallback?: () => void): void {
        console.log('游戏盒 4399 4399激励视频');
        //成功
        console.log('创建广告');
        const vd = gamebox.createRewardedVideoAd();
        console.log('加载广告');
        let lookOver = false;
        vd.onClose(() => {
            if (lookOver) {
                successCallback();
            } else {
                errorCallback && errorCallback('未播放完');
            }
            completeCallback && completeCallback();
            console.log('关闭广告');
            vd.destroy();
        });
        vd.onCompleted(() => {
            lookOver = true;
            console.log('播放广告 完毕');
        });
        vd.onLoad(() => {
            console.log('显示广告');
            vd.show().catch(() => {
                errorCallback && errorCallback('播放出错');
                completeCallback && completeCallback();
            });
        });
    }

    authorize(params: authorizeParams): void {
        params.success && params.success();
    }

    login(params: loginParams): void {
        params.success && params.success({code: null});
    }

    gameRecordStart(params: gameRecorderStartParams, onStart?: (res) => void): void {
        console.log('游戏盒 4399 录屏start');
        onStart && onStart(null);
    }

    gameRecordStop(): boolean {
        console.log('游戏盒 4399 录屏stop');
        return true;
    }

    shareGameRecordVideo(successCb?: () => void, failCb?: () => void): void {
        console.log('游戏盒 4399 分享录屏');
    }

    isProduction(): boolean {
        return gameBox4399.isProduction();
    }


    isHaveShareVideo(): boolean {
        return true;
    }

    reportAnalytics(EventKey: string, data: any): void {
        console.log('游戏盒 4399 发送埋点');
        return;
    }

    clearMemory(): void {

    }

    shareAppMessage(args: any): void {
    }

    operateGameLive(): void {
    }

    static isProduction(): boolean {
        return true;
    }

    createMoreGameBtn(): void {
    }

    hideBanner(): void {
    }

    showBannerAD(node: cc.Node, successCallback?: () => void, errorCallback?: (error: any) => void): void {
    }

    showInterstitialAd(onAdClose: () => void, onFailed: () => void): void {
    }

    showNativeAd(): void {
    }

    reportAdClickNativeAd(): void {

    }

    addShortcut(): Promise<boolean> {
        console.log('游戏盒 4399 添加桌面');
        //
        return Promise.resolve(true);
    }

    drawUrlImage(url: string, overCb: (spf: cc.SpriteFrame) => void): void {
        cc.assetManager.loadRemote(url, (err, asset: cc.Texture2D) => {
            if (err) {
                console.error('#1553937 图片出错', err);
                overCb(null);
                return;
            }
            overCb(new cc.SpriteFrame(asset));
        });
    }

    showVideo(videoUrl: string): void {
    }

    getShareVideoRank(sortType: SHARE_VIDEO_SORT_TYPE, successCb: (data: ShareVideoRankDetail[]) => void): void {
        successCb([]);
    }

    subscribeMessage(): void {
    }

    showAddFavoriteGuide(successCallback?: () => void, failCallback?: () => void, completeCallback?: () => void): void {
    }

    PlayLastRecordSound(scale?: number, successCb?: () => void, errorCb?: () => void): void {
        setTimeout(() => {
            successCb && successCb();
        }, 1000)
    }

    StartRecordSound(): void {
    }

    StopRecordSound(successCallback?: () => void): void {
        setTimeout(() => {
            successCallback && successCallback();
        }, 1000);
    }

    showModal(params: ModalParams): void {
        console.log('游戏盒 4399 对话框', params);
    }

    navigateToMiniGame(appId: string, successCallback?: () => void, failCallback?: () => void): void {
        console.log('游戏盒 4399 跳转到其他小游戏', appId);
        successCallback && successCallback();
    }

    fullScreenVideo(): Promise<void> {
        console.warn('H5 版本未接入全屏视频');
        return Promise.resolve(undefined);
    }
}


















